import { dateToYmd, ymdFromApiDate } from './field-details-date.util';

type SnapshotProduct = {
  id?: unknown;
  originDate?: unknown;
  productSourceType?: unknown;
  source?: unknown;
  productSource?: unknown;
};

function sourcePriority(product: SnapshotProduct): number {
  const raw = product.productSourceType ?? product.source ?? product.productSource;
  const normalized = String(raw ?? '')
    .trim()
    .toLowerCase();
  if (raw === 1 || normalized === '1' || normalized.includes('sentinel')) {
    return 0;
  }
  if (raw === 2 || normalized === '2' || normalized.includes('landsat')) {
    return 1;
  }
  return 2;
}

/** Selects one stable published RGB product id for the requested calendar day. */
export function pickSnapshotProductIdForDay(
  products: SnapshotProduct[] | null | undefined,
  selectedDate: Date | null | undefined,
): string | null {
  if (!selectedDate || Number.isNaN(selectedDate.getTime())) {
    return null;
  }

  const selectedDay = dateToYmd(selectedDate);
  const candidates = (products ?? [])
    .filter((product) => ymdFromApiDate(product.originDate) === selectedDay)
    .map((product, order) => ({
      id: String(product.id ?? '').trim(),
      order,
      priority: sourcePriority(product),
    }))
    .filter((candidate) => candidate.id.length > 0)
    .sort((a, b) => a.priority - b.priority || a.order - b.order);

  return candidates[0]?.id ?? null;
}
